import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=3dd2f362&scoped=true&"
import script from "./Subscriptions.vue?vue&type=script&lang=ts&"
export * from "./Subscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2f362",
  null
  
)

export default component.exports